var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundblob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3092",
    d: "M40,-67.2C49.2,-64.1,52,-47.9,58.3,-34.5C64.6,-21.1,74.4,-10.5,73.2,-0.7C72,9.1,59.7,18.2,48.5,23.3C37.4,28.3,27.4,29.3,19.5,37.2C11.6,45.1,5.8,60,-3.1,65.4C-12,70.7,-23.9,66.4,-32,58.6C-40.1,50.8,-44.4,39.4,-47.1,29.1C-49.9,18.7,-51.2,9.4,-53.4,-1.2C-55.5,-11.8,-58.4,-23.6,-51.6,-27.1C-44.9,-30.6,-28.5,-25.7,-18.3,-28.3C-8.1,-30.8,-4,-40.7,5.7,-50.6C15.5,-60.5,30.9,-70.4,40,-67.2Z",
    transform: "translate(100 100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundblob);
export default __webpack_public_path__ + "static/media/backgroundblob.22c67092db1d3cfb0d912e2564cad8b8.svg";
export { ForwardRef as ReactComponent };